import { useState, useRef } from "react";
import { FiCopy } from "react-icons/fi";

interface CopyInputProps {
  value: string;
  label?: string;
  animated?: boolean;
}

export function InputClickToCopy({ value, label, animated }: CopyInputProps) {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand("copy");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <>
      {animated ? (
        <>
          <div className="input-group">
            <div className="form-floating">
              <input
                ref={inputRef}
                type="text"
                className="form-control"
                value={value}
                readOnly
              />
              {label && <label>{label}</label>}
            </div>
            <button
              type="button"
              className="btn btn-light border-2"
              style={{ borderColor: "#f4f4f4" }}
              onClick={handleCopy}
            >
              {copied ? "Copiado!" : "Copiar"}
              <FiCopy className="ms-2" />
            </button>
          </div>
        </>
      ) : (
        <>
          {label && <label className="mb-2">{label}</label>}
          <div className="input-group">
            <input
              ref={inputRef}
              type="text"
              className="form-control"
              value={value}
              readOnly
            />
            <button
              type="button"
              className="btn btn-light border-2"
              style={{ borderColor: "#f4f4f4" }}
              onClick={handleCopy}
            >
              {copied ? "Copiado!" : "Copiar"}
              <FiCopy className="ms-2" />
            </button>
          </div>
        </>
      )}
    </>
  );
}
